import { GapSizeWiseModel } from "./gap-size-wise-data";


export class GapOrderDataModel {
    id:string;
    poNumber: string;
    buyerName: string;
    transMode: string;
    currency: string;
    buyerAddress: string;
    deliveryAddress: string;
    deliveryDate: string;
    exFactoryDate: string;
    incoterm:string;
    totalQuantity:string;
    status:string;
    unitPrice:string;
    color:string;
    style:string;
    styleDescription:string;
    sizeWiseData: GapSizeWiseModel[];






    constructor(

        id:string,
        poNumber: string,
        buyerName: string,
        transMode: string,
        currency: string,
        buyerAddress: string,
        deliveryAddress: string,
        deliveryDate: string,
        exFactoryDate: string,
        incoterm:string,
        totalQuantity:string,
        status:string,
        unitPrice:string,
        color:string,
        style:string,
        styleDescription:string,
        sizeWiseData: GapSizeWiseModel[]





    ) {

        this.id = id
        this.poNumber = poNumber
        this.buyerName = buyerName
        this.transMode = transMode
        this.currency = currency
        this.buyerAddress = buyerAddress
        this.deliveryAddress = deliveryAddress
        this.deliveryDate = deliveryDate
        this.exFactoryDate = exFactoryDate
        this.incoterm = incoterm
        this.totalQuantity = totalQuantity
        this.status = status
        this.unitPrice=unitPrice
        this.color=color
        this.style=style
        this.styleDescription=styleDescription
        this.sizeWiseData = sizeWiseData


    }
}


